import { render, staticRenderFns } from "./GetCustomersSpecialPrices.vue?vue&type=template&id=1baacd80&scoped=true&"
import script from "./GetCustomersSpecialPrices.vue?vue&type=script&lang=js&"
export * from "./GetCustomersSpecialPrices.vue?vue&type=script&lang=js&"
import style0 from "./GetCustomersSpecialPrices.vue?vue&type=style&index=0&id=1baacd80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baacd80",
  null
  
)

export default component.exports